// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/Images/heroBanner.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HeroSection_heroRightText__9Wwmw {
  color: #061c3d;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px; /* 160% */
  max-width: 520px;
  margin-left: auto;
}

.HeroSection_heroWrapper__ZAhJq {
  padding: 36px 48px 36px 24px;
  position: absolute;
  z-index: 10;
  top: 50%;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: auto;
  transform: translateY(-50%);
  max-width: 540px;
  background-color: #fff;
  border-radius: 0 50px 50px 0;
}
@media (max-width: 767px) {
  .HeroSection_heroWrapper__ZAhJq {
    background-color: transparent;
  }
}
.HeroSection_heroWrapper__ZAhJq h1 {
  color: rgb(24, 25, 24);
  font-family: Roboto;
  font-size: 36px;
  font-style: normal;
  font-weight: 600;
  line-height: 110%; /* 70.4px */
  margin-bottom: 16px;
  text-align: left;
}
@media (max-width: 767px) {
  .HeroSection_heroWrapper__ZAhJq h1 {
    font-size: 32px;
    color: #fff;
  }
}
.HeroSection_heroWrapper__ZAhJq .HeroSection_heroButton__aJcxd {
  font-family: Roboto;
  background: #df7752;
  height: 52px;
  width: 195px;
  border: 0;
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  border-radius: unset;
}

.HeroSection_ImageContent__6BRDs {
  position: relative;
  height: 90vh;
}
@media (max-width: 767px) {
  .HeroSection_ImageContent__6BRDs {
    height: 65vh;
  }
}
.HeroSection_ImageContent__6BRDs img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.HeroSection_heroContents__6O3rl {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  height: 86vh;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 120px;
}`, "",{"version":3,"sources":["webpack://./src/components/HeroSection/HeroSection.module.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,gBAAA;EACA,iBAAA;AACJ;;AACE;EACC,4BAAA;EACC,kBAAA;EACA,WAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,OAAA;EACA,WAAA;EACA,2BAAA;EACA,gBAAA;EACA,sBAAA;EACA,4BAAA;AAEJ;AADI;EAbF;IAcI,6BAAA;EAIJ;AACF;AAHI;EACE,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;EACA,mBAAA;EACA,gBAAA;AAKN;AAJM;EATF;IAUI,eAAA;IACA,WAAA;EAON;AACF;AALI;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;AAON;;AAJE;EACE,kBAAA;EACA,YAAA;AAOJ;AANI;EAHF;IAII,YAAA;EASJ;AACF;AARI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAUN;;AAPC;EACC,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;AAUF","sourcesContent":[".heroRightText {\n    color: #061c3d;\n    font-family: Roboto;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 32px; /* 160% */\n    max-width: 520px;\n    margin-left: auto;\n  }\n  .heroWrapper {\n   padding: 36px 48px 36px 24px;\n    position: absolute;\n    z-index: 10;\n    top: 50%;\n    margin-left: auto;\n    margin-right: auto;\n    left: 0;\n    right: auto;\n    transform: translateY(-50%);\n    max-width: 540px;\n    background-color: #fff;\n    border-radius: 0 50px 50px 0;\n    @media (max-width: 767px) {\n      background-color: transparent;\n    }\n    & h1 {\n      color: rgb(24 25 24);\n      font-family: Roboto;\n      font-size: 36px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 110%; /* 70.4px */\n      margin-bottom: 16px;\n      text-align: left;\n      @media (max-width: 767px) {\n        font-size: 32px;\n        color: #fff;\n      }\n    }\n    & .heroButton {\n      font-family: Roboto;\n      background: #df7752;\n      height: 52px;\n      width: 195px;\n      border: 0;\n      color: #fff;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: normal;\n      border-radius: unset;\n    }\n  }\n  .ImageContent {\n    position: relative;\n    height: 90vh;\n    @media (max-width: 767px) {\n      height: 65vh;\n    }\n    & img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n  }\n .heroContents{\n  background-image: url(\"../../assets/Images/heroBanner.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 86vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 120px;\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heroRightText": `HeroSection_heroRightText__9Wwmw`,
	"heroWrapper": `HeroSection_heroWrapper__ZAhJq`,
	"heroButton": `HeroSection_heroButton__aJcxd`,
	"ImageContent": `HeroSection_ImageContent__6BRDs`,
	"heroContents": `HeroSection_heroContents__6O3rl`
};
export default ___CSS_LOADER_EXPORT___;
